<template>
  <div id="app">
    <router-view name="header" class="header"></router-view>
    <div class="container shape-container d-flex">
      <div class="row w-100 shape-primary">
        <!-- Sticky Sidebar -->
        <div class="col-3" v-if="isHomeRoute">
          <div class="catalog sticky-sidebar">
            <!-- ✅ Sidebar Buttons with Tooltips -->
            <base-button class="text-left side-btn text--black" href="#" @click="navigateToCatalog('header_part')"
              title="Нүүр хуудас руу очих">
              Нүүр хуудас
            </base-button>

            <base-button class="text-left side-btn" href="#" @click="navigateToCatalog('lesson_part')"
              title="Сургалтын хэсэг рүү очих">
              Сургалт
            </base-button>
            <base-button class="text-left side-btn" href="#" @click="navigateToCatalog('info_part')"
              title="Зөвлөгөө, Мэдээлэлийн хэсэг рүү очих">
              Зөвлөгөө Мэдээлэл
            </base-button>
            <base-button class="text-left side-btn" href="#" @click="navigateToCatalog('teacher_part')"
              title="Багшийн хэсэг рүү очих">
              Багш
            </base-button>
            <!-- Зөвлөгөө, Мэдээлэл -->
            <!-- ✅ New Quick Links Section with Tooltips -->
            <div class="quick-links ">
              <h6 class="mt-4 mb-2">Программууд</h6>
              <ul v-for="link in links" :key="link.id">
                <li>
                  <a v-if="link.active" :href="link.link" target="_blank" rel="noopener noreferrer"
                    class="nav-link-inner--text">
                    <img :src="link.icon" alt="Icon" style=" height: 40px; margin-top: 5px;" />
                  </a>
                </li>
              </ul>
            </div>

            <!-- <div class="ad-section">
              <a href="https://taxacc.mn/" target="_blank">
                <img src="/img/theme/ad.png" alt="Ad" class="ad-img" />
              </a>
            </div> -->
          </div>
        </div>

        <!-- Main content area -->
        <div class="main-content" :class="isHomeRoute ? 'col-9' : 'col-12'">
          <router-view @scroll-to-section="handleScrollToSection" />
        </div>
      </div>
    </div>
    <router-view name="footer"></router-view>
  </div>
</template>

<script>
import authStore from "./stores/auth";
import axios from "axios";

if (process.env.NODE_ENV === 'production') {
  console.log = () => { };
  console.error = () => { };
}

export default {
  computed: {
    isHomeRoute() {
      const isHome = this.$route.path === "/";
      const isMobile = window.matchMedia("(max-width: 768px)").matches; // Example for mobile

      return isHome && !isMobile;
    }
  },
  data() {
    return {
      links: [],
    };
  },
  mounted() {
    this.checkAuthApp();
  },
  created() {
    this.fetchLinksDetails();
  },
  methods: {
    async checkAuthApp() {
      try {
        await this.$store.dispatch("auth/checkAuth");
      } catch (error) {
        console.error("Auth check failed:", error);
      } finally {
        this.$store.commit("auth/SET_INITIALIZED", true);
      }
    },
    scrollToSection(refName) {
      const section = this.$root.$refs[refName];
      if (section) {
        section.scrollIntoView({ behavior: 'smooth' });
      }
    },
    handleScrollToSection(sectionRef) {
      this.scrollToSection(sectionRef);
    },
    navigateToCatalog(lesson_part) {
      this.$router.push(`?catalog=${lesson_part}`);
    },
    async fetchLinksDetails() {
      try {
        const response = await axios.get(`/link_list`);
        this.links = response.data;
      } catch (error) {
        console.error("Failed to load Catalog details:", error);
      }
    },
  }
};
</script>

<style scoped>
#app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background: linear-gradient(to left,
      #e4e4e4 0%,
      rgba(228, 228, 228, 0.5) 50%,
      /* 50% opacity */
      #e4e4e4 100%);
}

.header {
  position: sticky;
  top: 0;
  z-index: 1000;
  background-color: rgb(41, 41, 44);
}

.main-content {
  flex: 1;
  padding-top: 50px;
  min-height: 100vh;
  padding-bottom: 20px;
}

.sticky-sidebar {
  width: 100% !important;
  position: sticky !important;
  top: 136px;
  overflow-y: auto;
  z-index: 999;
  display: flex;
  flex-direction: column;

}

@media (max-width: 768px) {
  .sticky-sidebar {
    display: none !important;
  }

  .header {
    position: static !important;
    top: 0;
    z-index: 1000;
    background-color: rgb(41, 41, 44);
  }
}

/* ✅ Style for Quick Links Section */
.quick-links {
  margin-top: 20px;
  padding: 10px;
  background-color: transparent;
  border-radius: 8px;
  /* box-shadow: 0 4px 8px rgba(0,0,0,0.1); */
}

.quick-links h6 {
  font-size: 16px;
  font-weight: 600;
  color: #343a40;
  margin-bottom: 10px;
}

.quick-links ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.quick-links li {
  margin-bottom: 8px;
}

.quick-links a {
  text-decoration: none;
  color: #007bff;
  font-size: 14px;
  display: flex;
  align-items: center;
}

.quick-links a:hover {
  text-decoration: underline;
}

footer {
  margin-top: auto;
  background-color: rgb(41, 41, 44);
}

/* ✅ Side Button Styling */
.side-btn {
  background: transparent;
  width: 95%;
  box-shadow: none;
  border: none;
  text-align: left;
  padding: 10px;
  font-size: 16px;
  color: #212529;
  transition: background-color 0.2s ease;
}

.side-btn:hover {
  background-color: #e9ecef;
  color: #2c2c2c;
}

/* .side-btn:focus {
  outline: none;
} */
.ad-section {
  margin-top: 20px;
  padding: 10px;
  /* background-color: #ffffff; */
  border: 0px solid #ddd;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  text-align: center;
}

.ad-img {
  width: 100%;
  /* Adjust width as needed */
  height: 150px;
  object-fit: cover;
  border-radius: 6px;
  /* transition: transform 0.3s ease; */
}

.ad-img:hover {
  transform: scale(1.05);
}
</style>